<template>
  <div v-loading="loading" class="render" :data-page-id="pageID">
    <FuxiLowcodeRender
      v-if="assetsJson && schemaJson && startRender"
      enable-cache
      :cache-level="3"
      :assets="assetsJson"
      :schema="schemaJson"
      :config="config"
      @load-start="action('load-start')"
      @load-end="action('load-end')"
      @render-start="action('render-start')"
      @render-end="action('render-end')"
      @render-error="action('render-error', $event)"
    />
    <pb-result
      v-if="!schemaUrl || !assetsUrl"
      icon="404"
      class="error"
      :title="
        $t('Gattaran_lowcode_xOev_XItQ') /** 未获取到该页面资源，请点击重试或联系平台管理员处理 */
      "
    >
      <template slot="extra">
        <pb-button type="primary" size="medium" @click="reload">
          {{ $t('FoodD_one_Try_again_qZka' /**重试 */) }}
        </pb-button>
      </template>
    </pb-result>
    <pb-result
      v-if="failed && !(!schemaUrl || !assetsUrl)"
      icon="loadFailed"
      class="error"
      :title="$t('Gattaran_lowcode_dnHP_Gabp') /** 页面加载失败，请点击重试或联系平台管理员处理 */"
    >
      <template slot="extra">
        <pb-button type="primary" size="medium" @click="reload">
          {{ $t('FoodD_one_Try_again_qZka' /**重试 */) }}
        </pb-button>
      </template>
    </pb-result>
  </div>
</template>
<script>
import fuxi from '@didi/fuxi-lowcode-vue-components'
import { useAppStore } from '@/store'
import { getLowcodeConfig, initFormilyI18n, initPebbleI18n } from './config'
import { trackEvent } from '@/plugins/plugin-init-omega'
import vue from 'vue'
import * as handle from 'vue'
const catchSchema = {}
const PEBBLE_CONFIG = {}
// 是否可以卸载window.vue的标志
// vue中A -> B页面 B的created先于A的Destory执行，需要设置标识避免低码页面互跳时没有window.Vue
let unmountWindowVueFlag = false
export default {
  name: 'LowcodeRender',
  components: {
    FuxiLowcodeRender: fuxi.FuxiLowcodeRender,
  },
  props: {
    assetsUrl: {
      type: String,
      default: '',
    },
    schemaUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      assetsJson: null,
      schemaJson: null,
      loading: false,
      failed: false,
      config: getLowcodeConfig(),
      loadTime: {
        start: '',
        end: '',
      },
      timer: null,
      renderTime: {
        renderSt: '',
      },
    }
  },
  computed: {
    pageID() {
      return this.$route.meta.pageID
    },
    activeMicroApp() {
      return this.$route.path.includes('/gtr_')
    },
    startRender() {
      const appStore = useAppStore()
      return (
        !appStore?.activeMicroAppConfig || (appStore?.activeMicroAppConfig && !this.activeMicroApp)
      )
    },
  },
  // eslint-disable-next-line vue/no-deprecated-destroyed-lifecycle
  beforeDestroy() {
    if (unmountWindowVueFlag) {
      window._vue_ = window.Vue
      window.Vue = null
      console.log('log ==> 卸载window.Vue')
    }
    this.timer && clearTimeout(this.timer)
  },
  created() {
    unmountWindowVueFlag = false
    this.init()
  },
  mounted() {
    unmountWindowVueFlag = true
  },
  methods: {
    async init() {
      this.loading = true
      try {
        this.initVue()
        let assetsContent, schemaContent
        if (!this.schemaUrl) return console.log('log ==> 未获取到schemaUrl')
        if (catchSchema[this.assetsUrl]) {
          console.log('log ==> catch-assets:', this.assetsUrl)
          assetsContent = catchSchema[this.assetsUrl]
        } else {
          assetsContent = await fetch(this.assetsUrl).then(res => res.json())
          catchSchema[this.assetsUrl] = assetsContent
        }
        if (catchSchema[this.schemaUrl]) {
          console.log('log ==> catch-schema:', this.schemaUrl)
          schemaContent = catchSchema[this.schemaUrl]
        } else {
          schemaContent = await fetch(this.schemaUrl).then(res => res.json())
          catchSchema[this.schemaUrl] = schemaContent
        }
        this.assetsJson = Object.freeze(assetsContent)
        this.schemaJson = Object.freeze(
          typeof schemaContent === 'string' ? JSON.parse(schemaContent) : schemaContent,
        )
        console.log('log ==> init', this.assetsJson, this.schemaJson, this.appConfig)
      } catch (error) {
        console.error(error)
        this.failed = true
      } finally {
        // 特殊情况低代码渲染器会渲染失败，同时未设置this.loading 状态，所以这里 setTimeout 兜底
        this.timer = setTimeout(() => {
          this.loading = false
        }, 5000)
      }
    },
    initVue() {
      Object.assign(PEBBLE_CONFIG, vue.prototype.$PEBBLE || {})
      if (window._vue_) {
        window.Vue = window._vue_
        return
      }
      window.Vue = vue
      Object.keys(handle).forEach(k => {
        window.Vue[k] = handle[k]
      })
      window.Vue.use = (...arg) => {
        // console.log('Low Code Component Log: Vue.use已被代理，注册无效')
      }
      const sourceComponentFun = window.Vue.component
      window.Vue.component = (...arg) => {
        const [componentName, component] = arg
        if (component && window.Vue.component(componentName)) {
          // console.log('Low Code Component Log: 当前组件已被注册，禁止重复注册')
          return
        }
        return sourceComponentFun.call(window.Vue, ...arg)
      }
    },
    action(type, error) {
      if (type === 'load-start') {
        this.loadTime.start = new Date().getTime()
      }
      if (type === 'load-end') {
        // 使用基座的pebble配置，覆盖低码默认的pebble配置
        window.Vue.prototype.$PEBBLE = PEBBLE_CONFIG
        initFormilyI18n(this.config.locale)
        initPebbleI18n(this.config.locale)
        this.loadTime.end = new Date().getTime()
      }
      if (type === 'render-start') {
        this.renderTime.renderSt = new Date().getTime()
      }
      if (type === 'render-end') {
        this.loading = false
        const { start, end } = this.loadTime
        const { renderSt } = this.renderTime
        trackEvent('tech_gattaran_lowcode_page_render_success_sw', '嵌入站页面曝光成功')
        trackEvent('tech_performance_custom', '自定义性能埋点', {
          timingCategory: `gattaran-lowcode-page-static-resource-performance`,
          timingName: `嵌入站静态资源加载时间`,
          timingValue: start && end ? end - start : null,
        })
        trackEvent('tech_performance_custom', '自定义性能埋点', {
          timingCategory: `gattaran-lowcode-page-load-timing`,
          timingName: `嵌入站页面加载时长`,
          timingValue: renderSt ? new Date().getTime() - renderSt : null,
        })
      }
      if (type === 'render-error') {
        this.loading = false
        this.failed = true
        trackEvent('tech_gattaran_lowcode_page_render_error_sw', '嵌入站页面曝光失败', {
          error,
        })
      }
    },
    reload() {
      location.reload()
    },
  },
}
</script>
<style lang="scss" scoped>
.render {
  height: calc(100% - 56px);
  display: flow-root;
  .error {
    margin: 16px;
    background: #fff;
    padding: 16px;
    border-radius: 8px;
    height: 100%;
    ::v-deep .pb-result__icon {
      svg {
        width: 256px;
        height: 256px;
      }
    }
  }
}
</style>
